import { Footer } from '../Widgets';
import React, { useState, useEffect } from 'react';

export const Cancellation = () => {
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-10 col-lg-offset-1">
                        <h2 className="module-title font-alt"><b>Return & Cancellation Policy</b></h2>
                        <div className="module-subtitle font-serif align-left" style={{ marginBottom: "10px" }}>
                            <ul>
                                <li>If a customer changes their mind and wants to cancel the order, then they have to contact our Customer Care executive. The cancellation will not be valid until it is confirmed by our respective department.</li>
                                <li>Cancellation requests will be considered only if the product is not dispatched. Once the order is shipped, customer cannot cancel the order.</li>
                                <li>If the customer has placed an order through Online Payment and cancels the order, then we will process for a refund within 15 working days.</li>
                                <li>Products once delivered can not be returned.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};